// frontend/src/pages/iqgames/fanratings/FanRatingsResult.jsx

import React, { useEffect, useState } from "react";
import useFanRatingsHook from "./useFanRatingsHook";

const FanRatingsResult = ({ question, onBack, onHome }) => {
  const { getResult } = useFanRatingsHook();

  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);

  useEffect(() => {
    loadResult();
  }, []);

  const loadResult = async () => {
    try {
      setLoading(true);

      const response = await getResult(question?._id);

      if (response?.success) {
        setResult(response.data);
      } else {
        setResult(null);
      }
    } catch (error) {
      console.error("FanRatings Result Error:", error);
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="py-16 text-center">
        <p className="text-gray-50 text-sm">Loading results...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-purple-950 p-4">
      <button
        onClick={onBack}
        className="mb-4 rounded-lg bg-fuchsia-700 hover:bg-fuchsia-600 text-white text-xs w-fit px-4 py-2"
      >
        ← Back
      </button>

      <div className="rounded-xl bg-gradient-to-br from-purple-900 to-fuchsia-900 border border-fuchsia-700 p-5">
        <h1 className="text-xl font-bold text-gray-50">
          🏆 Final Fan Rating Result
        </h1>

        <p className="text-xs text-gray-100 mt-2">{result.title}</p>
      </div>

      <div className="mt-6 rounded-xl bg-yellow-900/30 border border-yellow-500 p-5 text-center">
        <div className="text-5xl">👑</div>

        <h2 className="mt-3 text-xl font-bold text-yellow-400">
          {result.winner.name}
        </h2>

        <p className="text-sm text-gray-50 mt-2">Fan Favourite Winner</p>

        <div className="mt-4 flex justify-center gap-5">
          <div>
            <p className="text-xs text-gray-100">Rating</p>

            <p className="text-xl font-bold text-white">
              ⭐ {result.winner.rating}
            </p>
          </div>

          <div>
            <p className="text-xs text-gray-100">Votes</p>

            <p className="text-xl font-bold text-white">
              {result.winner.votes.toLocaleString()}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-3">
        <div className="rounded-xl bg-purple-900 border border-fuchsia-700 p-4">
          <p className="text-xs text-gray-100">Total Votes</p>

          <p className="text-xl font-bold text-white mt-1">
            {result.totalVotes.toLocaleString()}
          </p>
        </div>

        <div className="rounded-xl bg-purple-900 border border-fuchsia-700 p-4">
          <p className="text-xs text-gray-100">Community Score</p>

          <p className="text-xl font-bold text-yellow-400 mt-1">
            ⭐ {result.averageRating}
          </p>
        </div>
      </div>

      <div className="mt-6 rounded-xl bg-purple-900 border border-fuchsia-700 p-5">
        <h3 className="text-sm font-semibold text-gray-50">🥇 Top Ranking</h3>

        <div className="mt-4 space-y-3">
          {result.leaderboard.map((item) => (
            <div
              key={item.rank}
              className="flex justify-between items-center rounded-lg bg-purple-950 border border-fuchsia-900 p-3"
            >
              <div className="flex gap-3 items-center">
                <span className="text-xl">
                  {item.rank === 1 ? "🥇" : item.rank === 2 ? "🥈" : "🥉"}
                </span>

                <span className="text-sm text-white">{item.name}</span>
              </div>

              <span className="text-yellow-400 font-bold text-sm">
                ⭐ {item.rating}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-8 flex flex-row gap-3">
        <button
          onClick={() => {
            navigator.share
              ? navigator.share({
                  title: result.title,

                  text: `${result.winner.name} won Fan Ratings!`,

                  url: window.location.href,
                })
              : navigator.clipboard.writeText(window.location.href);
          }}
          className="rounded-xl bg-fuchsia-600 hover:bg-fuchsia-500 text-whitew-fit px-3 py-3 font-semibold"
        >
          📤 Share Result
        </button>

        <button
          onClick={onHome}
          className="rounded-xl border border-fuchsia-700 text-gray-50 w-fit px-3 py-3 font-semibold"
        >
          Back To Ratings Home
        </button>
      </div>

      <div className="mt-10 text-center">
        <p className="text-xs text-gray-100">
          Powered by{" "}
          <span className="text-gray-50 font-semibold">Think5Whys FanRatings</span>
        </p>
      </div>
    </div>
  );
};

export default FanRatingsResult;
